// extracted by mini-css-extract-plugin
module.exports = {"document-history":"document-history","document-history-item":"document-history-item"};